<template>
    <div class="item-menu">
        <a class="menu-btn" href="#">
          <i class="fa fa-trash-o" aria-hidden="true"></i>
        </a>
        <a class="menu-btn" href="#">
          <i class="fa fa-tag" aria-hidden="true"></i>
        </a>
        <a class="menu-btn" @click="shareBnt">
          <i class="fa fa-share-square-o" aria-hidden="true"></i>
        </a>
    </div>
</template>

<script>
import bus from '../bus'

export default {
  name: 'menuButton',
  data () {
    return {
    }
  },
  methods: {
    shareBnt () {
      bus.$emit('on-share-click', {})
    }
  }
}
</script>

<style scoped>
  .menu-btn > img{
    width: 100%;
    height: 100%;
  }
  .menu-btn{
    width: 30px;
    text-decoration: none;
    color: white;
    font-size: 28px;
    height: 30px;
    margin: 15px;
    cursor: pointer;
  }
  .menu-btn:last-child{
    margin-right: 25px;
  }
  .item-menu{
    display: flex;
    position: relative;
    justify-content: flex-end;
    background-color: rgba(0, 0, 0, 0.2);
    height: 120px;
    width: 98%;
    align-items: center;
    border-radius: 6px;
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// menuButton.vue?08060174